<template>
  <div class="individual-search-inner-container" @click="hideFilters">

    <ais-instant-search
        :search-client="searchClient"
        :index-name="algoliaPrefix + 'PROVIDERS'"
        :initial-ui-state="initialUiState"
        :insights-client="aa"
    >

      <!--            :around-lat-lng-via-iP.camel="true" -->
      <ais-configure filters="active:true"
                     v-bind="searchParameters"
                     :optional-filters.camel="optionalFilters"
                     :clickAnalytics="true"
      />



      <div class="mobile-filters-button btn btn-primary btn-gold" @click.stop="showFilters">Filters</div>

      <div class="container main-container">

        <transition name="fade" mode="out-in">
          <div class="left-panel-close-backing" v-if="showingFilters" @click.stop="hideFilters"></div>
        </transition>

        <div class="left-panel" :class="{ 'open': showingFilters }" @click.prevent.stop>


          <div class="pagination-value">
            <ais-stats>
              <template #default="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }"><p>
                Showing {{ (page * 8) + 1 }}-{{ (page * 8) + 8 }} of {{ nbHits }} results
              </p></template>
            </ais-stats>
          </div>


          <div class="mobile-filters-close" @click="hideFilters">Close Filters</div>

          <div class="side-filter">
            <h4 class="heading-4">Service name Starts With</h4>

            <div class="letter-grid">
              <div v-for="letter in letters" :key="letter">{{ letter }}</div>
            </div>
          </div>






          <div class="side-filter border-t-none">
          <h4 class="heading-4">Filter by Cilty</h4>
          <ais-refinement-list attribute="city" :limit="5" show-more>
            <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

              <ul>
                <li v-if="isFromSearch && !items.length">No results.</li>
                <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                  <a :href="createURL(item)" @click.prevent="refine(item.value)">
                    <span class="check"></span>
                    <span class="refinement-label">
                                            <ais-highlight attribute="item" :hit="item"/>
                                            <span class="count">({{ item.count.toLocaleString() }})</span>
                                        </span>
                  </a>
                </li>
              </ul>

              <button @click="toggleShowMore" :disabled="!canToggleShowMore" v-if="canToggleShowMore">
                {{ !isShowingMore ? 'View All' : 'Show less'}}
              </button>

            </div></template>
          </ais-refinement-list>

          </div>

          <ais-clear-refinements>
            <template #default="{ canRefine, refine, createURL }"><div>
              <a
                  :href="createURL()"
                  @click.prevent="refine"
                  v-if="canRefine"
                  class="clear-filters-button"
              >
                Clear Filters
              </a>
            </div></template>
          </ais-clear-refinements>

          <ais-configure :hitsPerPage="8" />
        </div>
        <div class="right-panel">

          <div class="tags-filter-reset">


              <div class="current-filters">
                <ais-current-refinements />
              </div>

            <div>
              <button class="clear">Clear All Filters</button>
            </div>
          </div>

          <ais-hits>

            <template #item="{ item }"><div class="individual-search-result-item">

              <div class="service-block">

              <h4><a class="heading-4 right-red-arrow d-block">Athletic Training</a></h4>
              <p>Lack of hearing during normal conversations can lead to a feeling of isolation. Advanced hearing aid technology can break down those barriers and get you back in the conversation.</p>
              </div>

              <div class="service-details">
                <ul>
                  <li>Bariatric Surgery</li>
                  <li>Weight Loss Consultations</li>
                  <li>Gastric Bypass Surgery</li>
                  <li>More...</li>
                </ul>
              </div>


            </div></template>

          </ais-hits>
        </div>

      </div>

      <div class="search-results-pagination">
        <ais-pagination>
          <template #default="{ currentRefinement, nbPages, pages, isFirstPage, isLastPage, refine, createURL }"><div class="ais-pagination-inner">
            <button :disabled="isFirstPage" class="btn btn-back btn-back-gold" :href="createURL(currentRefinement - 1)" @click.prevent="refine(currentRefinement - 1)">Previous</button>
            <button :disabled="isLastPage" class="btn btn-more" :href="createURL(currentRefinement + 1)" @click.prevent="refine(currentRefinement + 1)">Next</button>
          </div></template>
        </ais-pagination>
      </div>

    </ais-instant-search>

  </div>
</template>

<script>
import algoliasearch from 'algoliasearch';

const algoliaPrefix = (window.ajax_global && window.ajax_global.algolia_prefix) ? window.ajax_global.algolia_prefix : 'prod_';
const searchClient = algoliasearch('O4J2BVWP7X', '25e82b9ff49bfc98eeaea844742d9654');
const index = searchClient.initIndex(algoliaPrefix + 'PROVIDERS');

export default {

  props: ['query_in'],

  data() {
    return {
      query: '',
      originalQuery: '',
      letters: Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ'),
      algoliaPrefix,
      searchClient,
      index,
      initialUiState: {
        [algoliaPrefix + 'PROVIDERS']: {
          query: this.query_in,
          refinementList: {
            "active": true
          }
        },
      },
      optionalFilters: [
        'type:Doctors<score=2>',
        'type:Providers',
      ],
      // optionalFilters: [],
      searchParameters: {},
      showingFilters: false
    }
  },

  mounted() {

    this.query = this.query_in;
    this.originalQuery = this.query_in;

  },

  components: {},

  watch:{

    currentRefinement: function (oldValue, newValue) {
      // window.updateUrlParameter('query', newValue);
    }

  },

  methods: {

    formatPhoneNumber: function (phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    },

    formatArrayDisplay: function (array, maxLength = 0) {

      let returnString = '';

      if(maxLength > 0 && array.length > maxLength) {
        for (let i = 0; i < maxLength - 1; i++) {
          if(returnString === "") {
            returnString += this.decodeHTMLEntities(array[i]);
          } else {
            returnString += ', ' + this.decodeHTMLEntities(array[i]);
          }
        }
        returnString += ' + more';
      } else {
        for (let i = 0; i < array.length; i++) {
          if(returnString === "") {
            returnString += this.decodeHTMLEntities(array[i]);
          } else {
            returnString += ', ' + this.decodeHTMLEntities(array[i]);
          }
        }
      }

      return returnString;

    },

    decodeHTMLEntities: function (text) {
      var entities = [
        ['amp', '&'],
        ['apos', '\''],
        ['#x27', '\''],
        ['#x2F', '/'],
        ['#39', '\''],
        ['#47', '/'],
        ['lt', '<'],
        ['gt', '>'],
        ['nbsp', ' '],
        ['quot', '"']
      ];

      for (var i = 0, max = entities.length; i < max; ++i)
        text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

      return text;
    },

    showFilters: function () {

      this.showingFilters = true;

    },

    hideFilters: function () {

      this.showingFilters = false;

    },

    updateInput: function () {
      console.log(this.query);
    }

  }

}
</script>
